import * as types from '../actions';

export default function setScanID(scanID) {
  return {
    type: types.VIEWER_SET_SCAN_ID,
    scanID,
  };
}
